export default (that) => [
  {
    field: 'seq',
    width: 60,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    title: that.$l('table_label_masterNcNo') || '成品编码',
    field: 'masterNcNo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_ncNo') || '子件编码',
    field: 'ncNo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_custOrderNo') || '订单编号',
    field: 'custOrderNo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_factoryOrderNo') || '工厂订单编号',
    field: 'factoryOrderNo',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsName') || '产品名称',
    field: 'goodsName',
    width: 320,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsColor') || '产品颜色',
    field: 'goodsColor',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_goodsSpec') || '产品规格',
    field: 'goodsSpec',
    width: 200,
    align: 'center',
    showHeaderOverflow: true,
    formatter: ({ row }) => {
      const { spec, specUnit } = row
      return [spec, specUnit].filter(Boolean).join(' ')
    },
  },
  {
    title: that.$l('table_label_firstIssuesTime') || '首次返修时间',
    field: 'firstIssuesTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_qualityIssuesGroup') || '缺陷类型',
    field: 'qualityIssuesGroup',
    width: 250,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_totalNotPassQty') || '不良数量',
    field: 'totalNotPassQty',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reworkByName') || '指定返修人姓名',
    field: 'reworkByName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reworkByNo') || '工号',
    field: 'reworkByNo',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reworkProcessName') || '返修工序',
    field: 'reworkProcessName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reworkTechName') || '返修工艺',
    field: 'reworkTechName',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reworkStartTime') || '返修开始时间',
    field: 'reworkStartTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reworkTime') || '返修完成时间',
    field: 'reworkTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_pendingGoodsQualityIssuesStatus') || '复检结果',
    field: 'v_pendingGoodsQualityIssuesStatus',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_recheckTime') || '复检时间',
    field: 'recheckTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    title: that.$l('table_label_reworkNumber') || '累计返修次数',
    field: 'reworkNumber',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
    formatter: () => 1,
  },
  {
    title: that.$l('table_label_pendingGoodsQualityFinalStatus') || '最终状态',
    field: 'v_pendingGoodsQualityFinalStatus',
    width: 150,
    align: 'center',
    showHeaderOverflow: true,
  },
]
